import React from "react";

import Tab from "@busbud/design-system-components/dist/Tab/Tab";
import Tabs from "@busbud/design-system-components/dist/Tabs/Tabs";

import { useAppContext } from "@app/helpers/hooks";

import { useStyles } from "./floor-selector.styles";

type Props = {
  active_floor: number;
  className?: string;
  handleChange: (n: number) => void;
  without_border?: boolean;
  tab_size?: "sm" | "md" | "lg";
};

const FloorSelector = (props: Props) => {
  const { translator } = useAppContext();
  const { cx, classes } = useStyles();
  const { tab_size = "sm" } = props;

  return (
    <div className={props.className}>
      <Tabs
        className={cx(classes.tabs, {
          [classes.withoutBorder]: props.without_border
        })}
        variant="fullWidth"
        centered
        onChange={(_, value) => {
          props.handleChange(value);
        }}
        value={props.active_floor}
      >
        <Tab
          className={classes.tab}
          size={tab_size}
          value={0}
          label={translator.t("!checkout.seat-selection.first-floor")}
        />
        <Tab
          className={classes.tab}
          size={tab_size}
          value={1}
          label={translator.t("!checkout.seat-selection.second-floor")}
        />
      </Tabs>
    </div>
  );
};

export default FloorSelector;
